import script from "./VerifiedJobDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifiedJobDetails.vue?vue&type=script&setup=true&lang=js"

import "./VerifiedJobDetails.vue?vue&type=style&index=0&id=97311534&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97311534"]])

export default __exports__